<template>
  <div class="dsf-user-home">
    <div class="user-item user-info" v-if="user">
      <p class="title">考生信息</p>
      <div class="content">
        <div class="left">
          <!-- <el-avatar :src="user.photo" :size="60"></el-avatar> -->
          <el-avatar v-if="user.userId" :src="'/oua2/getUserPhoto?type=relativePath&userId=' + user.userId" :size="60"></el-avatar>
          <i class="icon iconfont icon-icon_man" v-if="user.sexValue == 0"></i>
          <i class="icon iconfont icon-icon_woman" v-else></i>
        </div>
        <div class="right">
          <p class="sub">
            <span>{{ user.name }}</span>
            <!-- <span class="sub-tip">（BI大数据事业部）</span> -->
          </p>
          <p class="info">
            <span class="info-item">
              <i class="iconfont icon-icon_phonenumber"></i>
              {{ user.phone }}
            </span>
            <span class="info-item">
              <i class="iconfont icon-icon_id"></i>
              {{ user.idCard }}
            </span>
          </p>
        </div>
      </div>
    </div>
    <DsfVirtualScroll class="list">
      <template v-for="(item, index) in data" >
        <div class="user-item" :key="index" v-if="item.type==0 || (item.type==1 && trainingType )">
          <p class="title">
            <span>正在进行中的{{ item.type === 0 ? "考试" : "练习" }}</span>
            <span class="more" @click="goMore(item.type)">更多 ></span>
          </p>
          <div class="content" v-for="(home, homeIndex) in item.homeInfoDtos" :key="homeIndex">
            <div class="left">
              <!-- exam、practice、homework -->
              <div class="icon-svg" :class="{ exam: item.type === 0, practice: item.type === 1 }">
                <img class="icon" v-if="item.type === 0" src="/static/img/icon_ks.png" alt="" />
                <img class="icon" v-else-if="item.type === 1" src="/static/img/icon_lx.png" alt="" />
                <img class="icon" v-else src="/static/img/icon_zy.png" alt="" />
              </div>
            </div>
            <div class="right">
              <p class="sub">
                <span>{{ home.name }} {{ home.batchName ? " " + home.batchName : "" }}</span>
              </p>
              <div class="operate">
                <span class="time">{{ home.examDateTime }}</span>
                <div v-if="item.type === 0" class="btns">
                  <DsfButton type="plain" title="查看结果" @click="getResult(home, item.type)" v-if="home.isExist == '1'">查看结果</DsfButton>
                  <DsfButton type="plain" title="考生须知" @click="getRules(home)">考生须知</DsfButton>

                  <DsfButton v-if="home['viewStatus'] == 2" title="继续考试" @click="continueExam(home, item.type)">继续考试</DsfButton>
                  <DsfButton
                    title="进入考试"
                    @click="goDetail(home, item.type)"
                    v-if="home.viewStatus == 1 || home.viewStatus == 4"
                    :disabled="home.viewStatus == 4 || remainTimes(home.list) == 0">进入考试</DsfButton
                  >
                  <DsfButton title="未开始" v-if="home.viewStatus === 3" :disabled="home.viewStatus === 3">未开始</DsfButton>
                </div>
                <div v-else-if="item.type === 1" class="btns">
                  <DsfButton type="plain" title="查看练习" @click="getResult(home, item.type)" v-if="home.isExist == '1'">查看练习</DsfButton>

                  <DsfButton title="继续练习" @click="goDetail(home, item.type, 2)" v-if="home.viewStatus === 2">继续练习</DsfButton>
                  <DsfButton
                    title="进入练习"
                    v-if="home.viewStatus === 1 || home.viewStatus === 4"
                    :disabled="home.viewStatus === 4 || trainingNum(home.list) == 0"
                    @click="goDetail(home, item.type, 1)">进入练习</DsfButton>
                  <DsfButton title="提示" v-if="trainingNum(home.list) == 0" @click="trainingTips()">提示</DsfButton>
                </div>
                <!-- <div v-else class="btns">
                  <DsfButton class="save-btn" title="进入作答" @click="goDetail(home, item.type)">进入作答</DsfButton>
                </div> -->
              </div>
              <div class="count">
                <div class="item" v-for="(li, liIndex) in home.list" :key="liIndex">
                  <p class="total">
                    {{ li.value }}<span class="unit">{{ li.unit }}</span>
                  </p>
                  <p class="tips">{{ li.text }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </DsfVirtualScroll>
  </div>
</template>

<script>
export default {
  name: "DsfUserHome",
  components: { },
  data() {
    return {
      hostport: "",
      user: null,
      data: [],
      styleopacity: { opacity: 0.5 },
    };
  },
  computed: {
    trainingType() {
      let training = dsf.config.setting_exam_enable_training;
      let type = training != "" && dsf.isDef(training) && Number(training);
      return type == 1 ? true : false;
    },
  },
  watch: {},
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.$http
        .all([this.$http.get("/manage/getHomeInfo", {}, $$webRoot.exam), this.$http.get("/examUser/getUserInfo", {}, $$webRoot.exam)])
        .then(async (res) => {
          this.data = res[0]?.data;
          this.user = res[1]?.data;
          if (this.user.photo && this.user.photo[0]) {
            this.user.photo = dsf.url.getWebPath(this.user.photo[0].relativePath);
          }
        });
    },

    getRules(item) {
      this.$openDialog({
        title: "考试须知",
        width: "700px",
        height: "650px",
        overflow: "auto",
        footerAlign: "center",
        params: {
          path: "exam/manage/examinfo?batchId=" + item.batchId,
        },
        btns: [
          {
            text: "确定",
            handler: function (res) {
              res.$dialog.close();
            },
          },
        ],
      });
    },

    //进入考试或练习
    goDetail(item, type, checkType) {
      var pathname = this.changeStr();
      if (type == 0) {
        let url = pathname + "#/pc/exam/manage/examinfo?batchId=" + item.batchId + "&share=0";
        // window.open(url);
        this.$openWindow(pathname + "#/pc/exam/manage/examinfo?batchId=" + item.batchId + "&share=0");
      } else {
        if (checkType === 2) {
          //继续练习
          this.$openWindow(pathname + "#/pc/exam/exam-practice?id=" + item.batchId + "&recordId=" + item.recordId);
        } else {
          //进入练习
          this.$openWindow(pathname + "#/pc/exam/exam-practice?id=" + item.batchId);
        }
      }
    },

    //继续考试
    continueExam(home, type) {
      var pathname = this.changeStr();
      if (type == 0) {
        this.$openWindow(pathname + "#/pc/exam/exam?recordId=" + home.recordId + "&type=manage");
      }
    },

    goMore(type) {
      const urls = {
        0: "manage/examlist",
        1: "training/traininglist",
      };
      const url = urls[type];
      this.$router.push({
        path: url,
        query: {},
      });
    },

    //练习提示
    trainingTips() {
      this.$alert("该练习暂未添加试题，无法开启练习，请联系管理员添加试题。", "提示", {
        confirmButtonText: "确定",
        callback: (action) => {
          this.$message({
            type: "info",
            message: `action: ${action}`,
          });
        },
      });
    },

    //查看考试结果
    getResult(home, type) {
      var pathname = this.changeStr();
      if (type == 0) {
        this.$openWindow(pathname + "#/pc/exam/check-exam-result?batchId=" + home.batchId + "&manageId=" + home.examManageId);
      } else {
        this.$openWindow(pathname + "#/pc/exam/practice-result?trainingId=" + home.batchId);
      }
    },

    //练习总题
    trainingNum(list) {
      var number = -1;
      list.forEach((element) => {
        if (element.text == "总题") {
          number = element.value;
        }
      });
      return number;
    },
    //剩余次数
    remainTimes(list) {
      var number = -1;
      list.forEach((item) => {
        if (item.text == "剩余次数") {
          number = item.value;
        }
      });
      return number;
    },
    //替换字符串
    changeStr() {
      var pathname = location.pathname;
      var arr = pathname.split("/");
      if (pathname.includes("index.html")) {
        arr.splice(arr.length - 1, 1);
        pathname = arr.join("/") + "/page.html";
      }
      return pathname;
    },
  },
};
</script>

<style></style>
